module.exports = __webpack_public_path__ + "antonio_pascarella-670x1024.jpg?b3bd2aaf48afca6153e7fbbc6e77b07f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/judge/antonio_pascarella-670x1024.jpg
// module id = 119
// module chunks = 0